import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/Overlay';

interface Props {
  text?: string,
  icon?: string,
  placement?: Placement
}

const Info: React.VFC<Props> = (props: Props) => {

  const {
    text,
    icon = "info-circle",
    placement
  } = props;


  return (
    !!text ?
      <OverlayTrigger
        placement={placement || 'auto'}
        overlay={
          <Tooltip id="tooltip-card">
            {text}
          </Tooltip>
        }>
        {({ ref, ...triggerHandler }) => (
          <i ref={ref} {...triggerHandler} className={`fas fa-${icon}`} />
        )}
      </OverlayTrigger> : <></>
  );

}


export default Info;
